export const isProduction = process.env.NODE_ENV === 'production'
export const isStaging = process.env.ENV === 'stg'
